const MENU = {
  EMPLOYEE_ACCOUNT: '従業員アカウント',
  ADMIN_ACCOUNT: '管理者アカウント',
  MANAGEMENT_ACCOUNT: '運営アカウント',
  AGENCY_ACCOUNT: '導入企業一覧',
  COMPANY_ACCOUNT: 'お知らせ',
  INQUIRY: 'お問い合わせ',
  PRIVACY_POLICY: 'プライバシーポリシー',
  USAGE_INFORMATION: 'ご利用情報/請求',
  AGENCY_PEE_STATEMENT: '代理店手数料明細書',
  OPERATION_LOG: '操作ログ',
  PREPAYMENT_HISTORY: '前払い履歴',
  ATTENDANCE_INFORMATION: '勤怠情報',
  USAGE_RECORD: '利用実績',
  INVOICE: '請求書',
  NOTICE: 'お知らせ',
  PRIVATE: '各種書類',
  PAYMENT_APPLICATION: '前払い申請',
  VARIOUS_DOCUMENT: '各種書類',
  // new operator
  OPE_MANAGEMENT_ACCOUNT: '運営アカウント',
  OPE_CORPORATE_ACCOUNT: '企業アカウント',
  OPE_AGENCY_ACCOUNT: '代理店アカウント',
  OPE_INQUIRY: 'お問い合わせ',
  NEW_POST: '新着情報 投稿',
  SETTING: 'その他/設定',
  OPE_AGENCY_PEE: '代理店手数料明細書',
};

const CONST_SIDE_BAR = { MENU };

export default CONST_SIDE_BAR;
